import { Component, Input } from "@angular/core";

@Component({
    selector: "login-background",
    template: `<div class="background-image-wrapper"></div>
        <div class="card-wrapper">
            <mat-card fxflex fxlayout fxlayoutalign="center">
                <img class="clare-logo" src="assets/images/signup/clarevision_blue_logo.svg" alt="clare logo" />
                <mat-card-title>
                    <ng-content select="[title]"></ng-content>
                </mat-card-title>
                <mat-card-content class="content-wrapper">
                    <ng-content></ng-content>
                </mat-card-content>
                <app-copyright-block *ngIf="!hideCopyright"></app-copyright-block>
            </mat-card>
        </div>`,
    styles: [
        `
            :host {
                display: flex;
                height: 100%;
                flex-direction: column;
                justify-content: safe center;
                text-align: center;
            }
            .background-image-wrapper {
                display: block;
                background-size: cover;
                position: fixed;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
            }

            .card-wrapper {
                background: transparent;
                position: relative;
                width: 100%;
            }

            mat-card {
                width: 70%;
                margin: 1.25rem auto;
                padding: 3rem;
                box-shadow: none !important;
                border: 1px solid #aaaaaa;
                background: #1a1a1a;

                @media screen and (max-width: 450px) {
                    border: none;
                    margin: 0;
                    padding: 1.5rem;
                    width: auto;
                }
            }

            mat-card-title {
                font-size: 1.25rem;
                font-weight: normal;
                padding-bottom: 0.9375rem;
            }

            mat-card-content {
                text-align: center;
            }

            mat-card-content > p {
                padding-top: 0.9375rem;
            }

            @media (min-width: 37.5rem) {
                .card-wrapper {
                    width: auto;
                }

                mat-card {
                    width: 25rem;
                }
            }

            .clare-logo {
                width: 103px;
                margin-bottom: 1.5rem;
            }
        `,
    ],
})
export class LoginBackgroundComponent {
    @Input() hideCopyright = false;
}
